
<div class="searchBlock" *ngIf="pageShowSearch">
    <div class="searchSection">   <i class="icon-search"></i>
      <div class="searchtxt">
        <input [formControl]='searchQuery' class="search-components textBox" type="text" placeholder="Search Stories &amp; Elements..."
        [(ngModel)]="str"  (focus)="searchFocus = true" (focusout)="searchFocus = false" autofocus/>
      </div>
    </div>
    <div class="filterSection spImg">
      <div class="fliterBlock"><i class="icon-filter"></i>
        <ul class="filterOption">
            <ng-container *ngIf="filterList !== 'false' && facets ">
                <ng-container *ngFor="let filter of filterList;let i = index">
                    <li class="togfilt" *ngIf="(i < 4)">
                        <filter [filterType]="filter.type" [displayName]="filter.name" [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                          [filterId]="filter.filter_id"  [facetNameMeta]="filter.facet_name_meta" (filterSelect)="urlUpdate($event)" [isDataKeyValuePair]="filter.isDataKeyValuePair"></filter>
                      </li>
                      <span [class]="((showMore) ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more')"
                      (click) = "(showMore = !showMore)"
                       *ngIf="(i === 4 && i > 3)">{{(showMore) ? 'less' : 'more'}}</span>
                      <li class="togfilt" *ngIf="(i > 3  && showMore)">
                          <filter [filterType]="filter.type" [displayName]="filter.name" [data]="getFilterData(filter.facet_name_meta)" [facetName]="filter.facet_name"
                            [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)" [isDataKeyValuePair]="filter.isDataKeyValuePair"></filter>
                        </li>
              </ng-container></ng-container>
        </ul>
    </div>
    <div class="closebg"></div>
  </div>
</div>
<div class="" [id]="(pageShowSearch) ? 'allcontentList' : 'allLiveList'" [ngClass]="(pageShowSearch) ? 'allcontentList' : 'allLiveList'" #autoscroll>
    <ng-template #loading>
        <div style="text-align: center; display: inline-block; width: 100%">
          <ng-container *ngIf="callFail">
            <div class="divCentre">
              Sorry, Server Error
            </div>
          </ng-container>
          <ng-container *ngIf="!callFail">
              <div class="imagepreloader">
                  <div class="a" style="--n: 5;">
                    <div class="dot dot1" style="--i: 0;"></div>
                    <div class="dot dot2" style="--i: 1;"></div>
                    <div class="dot dot3" style="--i: 2;"></div>
                    <div class="dot dot4" style="--i: 3;"></div>
                  </div>
                </div>
          </ng-container>
        </div>
      </ng-template>
  <ul >

  <ng-container *ngIf="pageShowNav;then navList else topList"> </ng-container>
  <ng-template #navList>
    <div class='container'  style="height: calc(100vh - 175px );" *ngIf="!pageShowSearch"
    [dragula]='"six-bag"' [id]="dragulaId" [dragulaModel]='pageNavList'>
  <ng-container *ngIf="pageNavList != null && pageNavList.length > 0;then listData else nores"></ng-container>
  <ng-template #listData>
  <ng-container *ngIf="pageNavList.length > 0;else loading">
      <ng-container *ngFor="let item of pageNavList; trackBy: trackByName; let i = index">
        <li id="{{item.id}}" type="{{item.pageType}}" value="{{i}}" [class]="(isLineup && item.pageType == 'EXTERNAL') ? 'highlight': ''">
          <div class="heading pin">
              <span class="number">{{i+1}}</span>
            {{item.name}}</div>
          <div class="status">
              <ul>
                  <li *ngIf="item.pageType == 'SUBSECTION'">
                      <span class="sectioncollection">{{item?.url.replace('/', '')}}</span> </li>
                <li><span class="sectioncollection">{{item?.pageType}}</span> </li>
                <li class="deleteStoryIcon"> <span class="deleteHeadline"><i class="icon-delete"
                  (click)="idToDelete(item.id)"></i></span>  </li>
              </ul>
          </div>
        </li>
      </ng-container>
   </ng-container>
  </ng-template>
</div>
</ng-template>
<ng-template #topList>
    <div class='container'  style="height: calc(100vh - 175px );" *ngIf="!pageShowSearch"
    [dragula]='"six-bag"' [id]="dragulaId" [dragulaModel]='listArray'>
  <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
  <ng-template #listData>
  <ng-container *ngIf="listArray.length > 0;else loading">
      <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
        <li id="{{item.id}}" type="{{item.pageType}}" value="{{i}}" [class]="(isLineup && item.pageType == 'EXTERNAL') ? 'highlight': ''">
          <div class="heading pin">
              <span class="number">{{i+1}}</span>
            {{item.name}}</div>
          <div class="status">
              <ul>
                  <li *ngIf="item.pageType == 'SUBSECTION'">
                      <span class="sectioncollection">{{item?.url.replace('/', '')}}</span> </li>
                <li><span class="sectioncollection">{{item?.pageType}}</span> </li>
                <li class="deleteStoryIcon"> <span class="deleteHeadline"><i class="icon-delete"
                  (click)="idToDelete(item.id)"></i></span>  </li>
              </ul>
          </div>
        </li>
      </ng-container>
   </ng-container>
  </ng-template>
</div>
</ng-template>
<div class='container'  style="height: calc(100vh - 175px );" *ngIf="pageShowSearch" [dragula]='"six-bag"'
 [id]="dragulaId" [dragulaModel]='listArray'>
  <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
  <ng-template #listData>
      <ng-container *ngIf="listArray.length > 0;else loading">
    <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
      <ng-container *ngIf="(parentPageId) ? (item.id !== parentPageId) : true">
      <li  id="{{item.id}}" type="{{item.pageType}}" value="{{i}}"
       [class]="(isNavLinkIds.indexOf(item?.id) > -1) ? 'ex-over-opac' : 'r' ">
        <div class="heading pin">
           {{htmlToPlaintext(item.name)}}</div>
        <div class="status">
            <ul>
                <li *ngIf="item.pageType == 'SUBSECTION'">
                    <span class="sectioncollection">{{item?.url.replace('/', '')}}</span> </li>
              <li><span class="sectioncollection">{{item?.pageType}}</span> </li>

              <li *ngIf="!pagePinList">
                  <a [routerLink]="routeLinkForList !== 'false' ? routeLinkForList + '/' + item.id : ''">
                  <span class="viewEye"><i class="icon-view-image"></i></span>
                </a>
              </li>
            </ul>
        </div>
      </li>
    </ng-container>
    </ng-container>
    </ng-container>
  </ng-template>
</div>



    <ng-template #nores>
      <div class="divCentre">
        No Data</div>
    </ng-template>
  </ul>


</div>
